export enum FunnelFlowModes {
  EDIT = 'EDIT',
  NOT_DEPLOYED = 'MODE_VIEW_NOT_DEPLOYED',
  DEPLOYMENT = 'MODE_VIEW_DEPLOYMENT',
}
